import { Box } from "@mui/material"
import { useShallow } from "zustand/shallow"

import { calculateCostBreakdownLineQuantity } from "@/screens/Procurement/CostBreakdown/utils"
import type { PurchaseOrderLineWithReceiptContext } from "@/screens/WarehouseReceiving/types"
import { formatPalletCount } from "@/screens/WarehouseReceiving/utils"
import { useUnitOfMeasurementsStore } from "@/stores/unitOfMeasurmentsStore"
import { formatNumber } from "@/utils/number"
import { getUomName } from "@/utils/uom"

interface CostBreakdownQuantityCellProps {
  purchaseOrderLine: PurchaseOrderLineWithReceiptContext
}

export const CostBreakdownQuantityCell: React.FC<CostBreakdownQuantityCellProps> = ({ purchaseOrderLine }) => {
  const uoms = useUnitOfMeasurementsStore(useShallow((s) => s.units))
  const quantity = calculateCostBreakdownLineQuantity(purchaseOrderLine)

  return (
    <>
      <Box>{formatPalletCount(quantity.palletsCount)}</Box>
      <Box>
        {formatNumber(quantity.regional.us.quantity)} {getUomName(uoms, quantity.regional.us.uomId)} (
        {formatNumber(quantity.regional.metric.quantity)} {getUomName(uoms, quantity.regional.metric.uomId)})
      </Box>
    </>
  )
}
